module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "3em!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Contents")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })])]), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "font-size": "1.1em!important",
      "margin-top": "2.5em!important"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/05a_author#anote",
      "id": "anote"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1.5em!important",
      "margin-bottom": "0.5em!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "font-size": "1.1em!important"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/07_part1#pt1",
      "id": "pt1"
    }
  }, [_vm._v("Building the Privateer "), _c('em', [_vm._v("Prince de Neufchatel")])])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1.5em!important",
      "margin-bottom": "0.5em!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "font-size": "1.1em!important"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/08_chapter1#ch1",
      "id": "ch1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1.5em!important",
      "margin-bottom": "0.5em!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "font-size": "1.1em!important"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/09_chapter2#ch2",
      "id": "ch2"
    }
  }, [_vm._v("The Masterclass")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1.5em!important",
      "margin-bottom": "0.5em!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "font-size": "1.1em!important"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/10_chapter3#ch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Model Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1.5em!important",
      "margin-bottom": "0.5em!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "font-size": "1.1em!important"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/11_epilogue#epi",
      "id": "epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1.5em!important",
      "margin-bottom": "0.5em!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "font-size": "1.1em!important"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/12_materialsandtools#mat",
      "id": "mat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Materials and Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1.5em!important",
      "margin-bottom": "0.5em!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "font-size": "1.1em!important"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/13_furtherreading#fr",
      "id": "fr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6046a5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/05_toc.vue
// module id = 69
// module chunks = 0